import { useMutation, useQuery, useQueryClient } from 'react-query'
import rbacAPI, { AppRoleError } from '../service/rbacAPI'
import { AppRole, AppRoleMembersResponse } from '../types/rbac.types'
import { APP_ROLE_QUERY_KEY, useAuthScope } from './useAppRole'

export const APP_ROLE_MEMBERS_QUERY_KEY = ['app-roles', 'members']

export const useAppRoleMembers = (enabled = true) => {
  const { userId, accountId } = useAuthScope()
  return useQuery<AppRoleMembersResponse, AppRoleError>({
    queryKey: [...APP_ROLE_MEMBERS_QUERY_KEY, userId, accountId],
    queryFn: rbacAPI.getAppRoleMembers,
    enabled,
    retry: 1,
  })
}

export const useUpdateAppRole = () => {
  const queryClient = useQueryClient()
  return useMutation<void, AppRoleError, { userId: string; appRole: AppRole }>({
    mutationFn: ({ userId, appRole }) => rbacAPI.updateAppRole(userId, appRole),
    onSuccess: () => {
      // L'admin peut s'être rétrogradé lui-même : on recharge aussi son rôle.
      queryClient.invalidateQueries(APP_ROLE_QUERY_KEY)
      queryClient.invalidateQueries(APP_ROLE_MEMBERS_QUERY_KEY)
    },
  })
}
